export enum AppEnvironment {
  Development = "development",
  Production = "production",
}

export interface Environment {
  production: boolean;
  appEnvironment: AppEnvironment;
  baseUrl: string;
  assetsPathUrl: string;
  sessionName: string;
  itemsPerPage: number;
}

const environmentValues: Record<
  AppEnvironment,
  Pick<
    Environment,
    "baseUrl" | "assetsPathUrl" | "sessionName" | "itemsPerPage"
  >
> = {
  [AppEnvironment.Development]: {
    baseUrl: "https://dev.intrasense.co.uk/app/api/",
    assetsPathUrl: "https://dev.intrasense.co.uk/app/",
    sessionName: "instrasense-user:session",
    itemsPerPage: 10,
  },
  [AppEnvironment.Production]: {
    baseUrl: "https://intrasense.co.uk/app/api/",
    assetsPathUrl: "https://intrasense.co.uk/app/",
    sessionName: "instrasense-user:session",
    itemsPerPage: 10,
  },
};

export function buildEnvironment(appEnvironment: AppEnvironment): Environment {
  return {
    ...environmentValues[appEnvironment],
    appEnvironment,
    production: appEnvironment === AppEnvironment.Production,
  };
}

/*

RUN THE CODE:
DEV: npx nx serve website
PROD: npx nx serve website --configuration=production

BUILD: 
DEV: npx nx build website --configuration=development
PROD: npx nx build website --configuration=production


*/